<style lang="less" scoped>
.kyltcom{position: relative;width: 100%;margin: 0;padding: 0;background: #fff;font-family: AlibabaPuHuiTi-Medium;margin-bottom: 20px;}
.first{display: flex;justify-content:space-between;width: 1200px;margin:auto;margin-top: 10px;}
.second{display: flex;flex-direction: column;width: 810px;margin-right: 40px;}
.third{display: flex;flex-direction: column;width: 350px;}
.firsttitle{margin-top: 20px;display: flex;
  i{margin-top: 2px;font-size: 19px;color: #289FDE;float: left; margin-right: 10px;}
  span{font-size: 18px;font-weight: 600;}
}
.firstlist{margin: 20px 0px;display: flex;flex-direction: column;
  span{font-size: 18px;text-align: left;color:black;margin: 10px 28px;}
  span:hover{color: #2f80dd;cursor: pointer;}
}
.sticky{position: sticky; top: 10px;margin: 0px;display: flex;flex-direction: column;justify-content:center;}
.secondtitle{margin-top: 10px;display: flex;
  i{margin-top: 3px;font-size: 16px;color: #289FDE;float: left;margin-right: 5px;}
  span{font-size: 18px;font-weight: 600;}
}
ul{margin-left: -10px;}
li{text-align: left;}
li:hover{color: #2f80dd;cursor: pointer;}
</style>

<template>
  <div class="kyltcom">
    <div class="first">
      <div class="second">
        <router-view />
      </div>
      <div class="third">
        <div class="firsttitle">
          <i class="iconfont icon-fuwuerji"></i><span>参会服务 / Participation services</span>
        </div>
        <div class="firstlist">
          <span @click="goCHBM">参会报名</span>
          <span @click="goHYRC">会议日程</span>
          <span @click="goLTGK">论坛概况</span>
          <span @click="goZLHGK">展览会概况</span>
        </div>
        <div class="sticky">
          <div class="secondtitle">
            <i class="iconfont icon-zuixinnewchunse"></i><span>往届回顾 / Previous reviews</span>
          </div>
          <ul>
            <li v-for="(item, index) in List" :key="index" @click="goDetails(item)" >
            <p>{{ item.dispc }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 何宽
 * 矿业论坛列表页、大会新闻详情页、论坛概况、论坛展览会 公共部分页面
 */
export default {
  name: '',
  data()
  {
    return {
      List: []
    }
  },
  created()
  {
    this.getList()
  },
  methods: {
    getList()
    {
      let paras = {cmd: 'query', _major: 99, _minor: 20, _exp: 'moduleid = 20', orderby: 'id Desc'}
      window.post.getPost(paras).then((ret) =>
      {
        let arr = []
        ret.forEach(item =>
        {
          if (item.dispc.substr(0, 1) === '2')
            arr.push({id: item.id, dispc: item.dispc})
        })
        this.List = arr
      })
    },
    // 点击列表项，跳转到详情页面
    goDetails(item)
    {
      if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))
        this.$router.push({path: '/NewsListApp', query: {id: item.id}})
      else
        this.$router.push({path: '/NewsList', query: {id: item.id}})
    },
    goCHBM()
    {
      // let url = this.$router.resolve({path: '/chbm'})
      // window.open(url.href, '_blank')
      window.open('https://www.camining.cn/nav/index.html', '_blank')
    },
    goHYRC()
    {
      if (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))
      {
        let url = this.$router.resolve({path: '/PromoinApp', query: {kw: 'hyrc'}})
        window.open(url.href, '_blank')
      }
      else
      {
        let url = this.$router.resolve({path: '/Promoin', query: {kw: 'hyrc'}})
        window.open(url.href, '_blank')
      }
    },
    goLTGK()
    {
      let url = this.$router.resolve({path: '/Ltgk'})
      window.open(url.href, '_blank')
    },
    goZLHGK()
    {
      let url = this.$router.resolve({path: '/Ltzlhgk'})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/KyltCom.vue